export interface IPrefecture {
  ID?: number;
  Name?: string;
  prefectureName?: string;
  id?: string;
}

export class Prefecture implements IPrefecture {
  ID?: number;
  Name?: string;
  prefectureName?: string;
  id?: string;

  constructor();
  constructor(obj: IPrefecture);
  constructor(obj?: IPrefecture) {
    this.ID = obj?.ID ?? -1;
    this.Name = obj?.Name ?? '';
    this.id = obj?.id ?? '';
    this.prefectureName = obj?.prefectureName ?? '';
  }
}
